export enum RedirectionTypeEnum {
  INTERNAL = "INTERNAL",
  CHECK_EMAIL = "CHECK_EMAIL",
  EXTERNAL = "EXTERNAL",
  NEW_USER = "NEW_USER",
}
